import React from 'react';
import PropTypes from 'prop-types';
import { Grid, Card, CardContent, Typography, Button, CardMedia, Box } from '@mui/material';
import { Link, useNavigate } from 'react-router-dom';
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos';
import imgAvanzado from '../../assets/diplomadoAvanzado.webp';
import imgMaestria from '../../assets/doppler3.webp';
import imgBasico from '../../assets/diplomadoBasico.webp';

const diplomasData = [
  {
    title: 'DIPLOMADO BASICO',
    description: 'DIPLOMADO BASICO EN ULTRASONIDO DIAGNOSTICO PARA MEDICOS GENERALES Y DIVERSOS ESPECIALISTAS',
    image: imgBasico,
    route: '/diplomado-basico',
  },
  {
    title: 'DIPLOMADO AVANZADO',
    description: 'ACTUALIZACION EN EL ULTRASONIDO GINECOLOGICO DOPPLER MATERNO FETAL Y ECOCARDIOGRAFIA FETAL',
    image: imgAvanzado,
    route: '/diplomado-avanzado',
  },
  {
    title: 'MAESTRIA',
    description: 'MAESTRIA EN ULTRASONIDO DIAGNOSTICO',
    image: imgMaestria,
  },
];

const DiplomaCard = ({ title, description, image, route, onClick, isComingSoon }) => (
  <Card
    sx={{
      borderRadius: 4,
      boxShadow: '0px 6px 20px rgba(0, 0, 0, 0.15)',
      transition: 'transform 0.3s, box-shadow 0.3s',
      minHeight: '500px',
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'space-between',
      background: 'linear-gradient(to bottom, #ffffff, #f7f7f7)',
      '&:hover': {
        transform: 'translateY(-10px)',
        boxShadow: '0px 12px 40px rgba(0, 0, 0, 0.2)',
      },
      cursor: route ? 'pointer' : 'default',
    }}
    onClick={onClick}
  >
    <Box
      sx={{
        padding: 2,
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
      }}
    >
      <CardMedia
        component="img"
        image={image}
        alt={`Imagen de ${title}`}
        sx={{
          height: '250px',
          width: '100%',
          maxWidth: '500px',
          borderRadius: '16px',
          objectFit: 'cover',
        }}
      />
    </Box>
    <CardContent
      sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        textAlign: 'center',
        padding: 3,
        flexGrow: 1,
      }}
    >
      <Typography
        variant="h6"
        sx={{
          fontWeight: 700,
          marginBottom: 1,
          color: '#2c3e50',
          textTransform: 'uppercase',
          fontSize: '1.25rem',
        }}
      >
        {title}
      </Typography>
      <Typography
        variant="body1"
        sx={{
          marginBottom: isComingSoon ? 1 : 3,
          color: '#5d6d7e',
          lineHeight: 1.6,
        }}
      >
        {description}
      </Typography>
      {isComingSoon && (
        <Typography
          variant="body2"
          sx={{
            color: '#e74c3c',
            fontWeight: 'bold',
            marginBottom: 3,
            fontSize: '1rem',
          }}
        >
          Próximamente
        </Typography>
      )}
      <Button
        component={Link}
        to={route}
        variant="contained"
        sx={{
          px: { xs: 3, md: 4 },
          py: { xs: 1, md: 1.5 },
          fontSize: { xs: '0.9rem', md: '1rem' },
          fontWeight: 600,
          color: '#fff',
          backgroundColor: 'rgb(51, 64, 64)',
          borderRadius: '8px',
          boxShadow: '0 4px 15px rgba(0, 0, 0, 0.2)',
          transition: 'all 0.3s ease',
          '&:hover': {
            backgroundColor: 'rgb(41, 54, 54)',
            transform: 'scale(1.05)',
            boxShadow: '0 6px 20px rgba(0, 0, 0, 0.3)',
          },
        }}
        endIcon={<ArrowForwardIosIcon />}
      >
        Ver diplomados disponibles
      </Button>
    </CardContent>
  </Card>
);



DiplomaCard.propTypes = {
  title: PropTypes.string.isRequired,
  description: PropTypes.string.isRequired,
  image: PropTypes.string.isRequired,
  route: PropTypes.string.isRequired,
  onClick: PropTypes.func.isRequired,
};

const Diplomas = () => {
  const navigate = useNavigate();

  return (
    <Box sx={{ mx: 4 }}>
      <Grid container spacing={4} justifyContent="center">
        {diplomasData.map((diploma, index) => (
          <Grid item xs={12} sm={6} md={4} key={index}>
            <DiplomaCard
              {...diploma}
              onClick={() => diploma.route && navigate(diploma.route)}
              isComingSoon={diploma.title === 'MAESTRIA'}
            />
          </Grid>
        ))}
      </Grid>
    </Box>
  );
};
export default Diplomas;
